import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Returns true when at least one blog post is published, so the public menu
 * (Header + Footer) can conditionally show/hide the Blog link.
 *
 * Cached in sessionStorage for the browser session to avoid a request on
 * every navigation. Handles both the current `{items,total}` response and
 * the legacy plain-array response.
 */
export default function useHasBlog() {
    const [hasBlog, setHasBlog] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.sessionStorage.getItem("hasBlog") === "1";
    });

    useEffect(() => {
        let cancelled = false;
        // Ask for `limit=1` — we only need to know if there's any published post.
        api.get("/blog", { params: { limit: 1 } })
            .then((r) => {
                if (cancelled) return;
                const payload = r.data || {};
                const has = Array.isArray(payload)
                    ? payload.length > 0
                    : (payload.total ?? (payload.items ? payload.items.length : 0)) > 0;
                setHasBlog(has);
                try { window.sessionStorage.setItem("hasBlog", has ? "1" : "0"); } catch { /* ignore */ }
            })
            .catch(() => {});
        return () => { cancelled = true; };
    }, []);

    return hasBlog;
}
